module.exports = __webpack_public_path__ + "static/media/img-24.083a5f73.jpg";